<template>
  <v-container pa-0 fluid>
    <v-card min-width="550px">
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text v-if="agent">
        <v-row>
          <v-col
            >Company Code: <strong>{{ agent.companyCode }}</strong></v-col
          >
          <v-col
            >Currency:
            <strong>{{ agent.financeSettings.currencyCode }}</strong></v-col
          >
        </v-row>
        <v-row>
          <v-col
            >Accommodation Markup:
            <strong
              >{{ agent.financeSettings.accommodationMarkup }}%</strong
            ></v-col
          >
          <v-col
            >Accommodation Commission:
            <strong
              >{{ agent.financeSettings.accommodationCommision }}%</strong
            ></v-col
          >
        </v-row>
        <v-row>
          <v-col
            >Activities Markup:
            <strong
              >{{ agent.financeSettings.activitiesMarkup }}%</strong
            ></v-col
          >
          <v-col
            >Activities Commission:
            <strong
              >{{ agent.financeSettings.activitiesCommision }}%</strong
            ></v-col
          >
        </v-row>
        <v-row>
          <v-col
            >Transport Markup:
            <strong>{{ agent.financeSettings.transportMarkup }}%</strong></v-col
          >
          <v-col
            >Transport Commission:
            <strong
              >{{ agent.financeSettings.transportCommision }}%</strong
            ></v-col
          >
        </v-row>
        <v-row>
          <v-col
            >Travel Markup:
            <strong>{{ agent.financeSettings.travelMarkup }}%</strong></v-col
          >
          <v-col
            >Travel Commission:
            <strong>{{ agent.financeSettings.travelCommision }}%</strong></v-col
          >
        </v-row>
        <v-row>
          <v-col
            >Other Markup:
            <strong>{{ agent.financeSettings.otherMarkup }}%</strong></v-col
          >
          <v-col
            >Other Commission:
            <strong>{{ agent.financeSettings.otherCommision }}%</strong></v-col
          >
        </v-row>
        <v-row>
          <v-col
            >Package Markup:
            <strong>{{ agent.financeSettings.packageMarkup }}%</strong></v-col
          >
          <v-col
            >Package Commission:
            <strong
              >{{ agent.financeSettings.packageCommision }}%</strong
            ></v-col
          >
        </v-row>
        <code v-if="debug">{{ agent }}</code>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
const INFO = gql`
  query agentInfo($id: ID!) {
    agent(id: $id) {
      name
      companyCode
      financeSettings {
        currencyCode
        taxType
        accommodationMarkup
        accommodationCommision
        activitiesMarkup
        activitiesCommision
        transportMarkup
        transportCommision
        travelMarkup
        travelCommision
        otherMarkup
        otherCommision
        packageMarkup
        packageCommision
      }
    }
  }
`;
export default {
  name: "agent-info-tooltip",

  props: {
    agentId: {
      type: String,
      default: () => "",
    },
  },

  data() {
    return {
      debug: false,
    };
  },

  computed: {
    title() {
      return this.agent ? this.agent.name : "Agent";
    },
  },

  apollo: {
    agent: {
      query: INFO,
      variables() {
        return {
          id: this.agentId,
        };
      },
      skip() {
        return this.agentId == "";
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/AgentInfoTooltip.vue